/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import { Link, NavLink } from "react-router-dom";
import {Tooltip} from 'antd';
import DokanIcons from "../../components/icon/DokanIcons";
import DokanTableEditDropdown from "../../components/table/DokanTableEditDropdown";
import DokanTableItemPublishedDate from "../../components/table/DokanTableItemStatus/DokanTableItemPublishedDate";
import DokanTablePillTags from "../../components/table/DokanTablePillTags";

// Column data as render props pattern

const orderTableColumnData = [
  {
    title: "Order",
    dataIndex: "id",
    key: "id",
    render: (text, record) => (
      <NavLink
        exact
        to={`orders/${record.id}`}
        className="text-primary hover:text-primary"
      >
        <div className="text-base text-black font-bold flex gap-3">
          <div>Order {`${record.id}`}</div>
          <div>
            {record.status === 'processing'  && <Tooltip placement="top" title="backorder"> <DokanIcons icon="#back_order" /></Tooltip>}
            {record.status === 'on-hold' && <Tooltip placement="top" title="partial refund"> <DokanIcons icon="#partial_refund" /></Tooltip>}
            {record.id > 6 && record.id <= 10 && (
              <DokanIcons icon="#discount" size="4" />
            )}
          </div>
        </div>
      </NavLink>
    ),
    responsive: ['sm']
  },

  {
    title: "Order Total",
    dataIndex: "total",
    key: "id",
    render: (total, record) => (
      <p className="text-sm text-secondary font-light">
        {record.currency} {record.total}
      </p>
    ),
    responsive: ['md']
  },
  {
    title: "Earning",
    dataIndex: "earning",
    key: "id",
    render: () => <p className=" text-sm text-secondary font-light">$0*</p>,
    responsive: ['md']
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "id",
    render: (status, record) => (
      <DokanTablePillTags variant={record.status}>
        {record.status}
      </DokanTablePillTags>
    ),
    responsive: ['sm']
  },
  {
    title: "Customer",
    dataIndex: "created_via",
    key: "id",
    render: (_, record) => (
      <p className="text-sm text-secondary font-light">{record.billing.first_name}</p>
    ),
    responsive: ['md']
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "id",
    render: (date, record) => (
      <DokanTableItemPublishedDate date={record.date_created} />
    ),
    responsive: ['md']
  },
  {
    title: "Location",
    dataIndex: "location",
    key: "id",
    render: (_ , record) => <p className="text-sm text-secondary font-light">{record.shipping.city ? record.shipping.city : record.billing.city}</p>,
    responsive: ['md']
  },
//   {
//     title: "",
//     dataIndex: "",
//     key: "id",
//     render: (menu, record) => <DokanTableEditDropdown record={record} />,
//   },
];

export default orderTableColumnData;
